import React, { Component, Fragment } from 'react';
import Header from './Header';

class AuthLayout extends Component {

  componentDidMount() {
    document.body.removeAttribute('class');
    document.body.classList.add('auth-bg');
  }
  componentWillUnmount() {
  }

  render() {
    return (
      <Fragment>
        <Header />
        <div className="layout-wrap auth">
          {this.props.children}
        </div>
      </Fragment>
    );
  }
}

export default AuthLayout;